// src/icons/svgs/line-height.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgLineHeight = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none", viewBox: "0 0 18 18", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { stroke: "#343A40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.125, d: "m2.063 13.759 1.494 1.528a.9.9 0 0 0 .643.27m0 0a.9.9 0 0 0 .643-.27l1.495-1.528M4.2 15.557V2.443M2.063 4.208l1.501-1.502a.9.9 0 0 1 .636-.263m0 0a.9.9 0 0 1 .638.263l1.5 1.502" }),
  /* @__PURE__ */ jsx("path", { stroke: "#343A40", strokeLinecap: "round", strokeWidth: 1.125, d: "M8.662 3.188h7.275M8.663 14.813h7.275" }),
  /* @__PURE__ */ jsx("path", { stroke: "#343A40", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.125, d: "m9.84 11.696.878-2.064m0 0h3.165m-3.165 0 1.347-3.164a.251.251 0 0 1 .47 0l1.348 3.163.879 2.065" })
] });
var ForwardRef = forwardRef(SvgLineHeight);
var line_height_default = ForwardRef;
export {
  line_height_default as LineHeight
};
